<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableSecurityGroupListData"
      style="width: 100.1%;"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableSecurityGroupVue = {};
export default {
  name: "TableEcs",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      val: "",
      columns: [
        {
          title: this.$t("RAM.AWS.computeInstance.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("permission_configuration_management.account.accountId"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.computeInstance.region"),
          key: "region"
        },
        {
          title: this.$t('RAM.AWS.ECS.clusterName'),
          key: "clusterName",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$router.push({
                      path: "/resourceConfigurationManagement/aws/ecs/clusterDescription",
                      query: {
                        id: params.row.id
                      }
                    });
                  }
                }
              },
              params.row.clusterName
            );
          }
        },
        {
          title: this.$t('RAM.AWS.ECS.service'),
          key: "activeServicesCount"
        },
        {
          title: this.$t('RAM.AWS.ECS.task'),
          key: "task"
        },
        {
          title: this.$t('RAM.AWS.ECS.containerInstance'),
          key: "registeredContainerInstancesCount"
        },
        {
          title: this.$t('RAM.AWS.ECS.monitoring'),
          key: "cloudWatchStatusName"
        },
        {
          title: this.$t('RAM.AWS.ECS.capacityProviderStrategy'),
          key: 'defaultCapacityProviderStrategy'
        }
      ],
      tableSecurityGroupListData: []
    };
  },
  beforeCreate: function() {
    tableSecurityGroupVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("accountName", function(val) {
      tableSecurityGroupVue.accountName = val;
    });
    eventBus.$on("companyId", function(val) {
      tableSecurityGroupVue.companyId = val;
    });
    eventBus.$on("clusterName", function(val) {
      tableSecurityGroupVue.clusterName = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableSecurityGroupVue.getSecurityGroupListData();
    },
    // 分页显示数据
    /****************************************************/
    getSecurityGroupListData: function() {
      var pageSecurityGroupDate = {
        pageNum: this.current,
        pageSize: this.pageSize,
        accountName: tableSecurityGroupVue.accountName,
        companyId: tableSecurityGroupVue.companyId,
        clusterName: tableSecurityGroupVue.clusterName
      };
      this.$api.cmdb
        .pagingQueryAWSEcs(pageSecurityGroupDate)
        .then(res => {
          this.tableSecurityGroupListData = res.data.records;
          this.tableSecurityGroupListData.forEach(item => {
            item.task = `${item.pendingTasksCount} ${this.$t('KPI.pending')} | ${item.runningTasksCount} ${this.$t('RAM.AWS.ECS.running')}`
          })
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableSecurityGroupVue.getSecurityGroupListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableSecurityGroupVue.getSecurityGroupListData();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/ecs/TableECS.vue